import EmbedDataWrapper from '@/components/embeds/EmbedDataWrapper/EmbedDataWrapper'
import EmbedHtml from '@/components/embeds/EmbedHtml/EmbedHtml'
import { Infographic as InfographicTypes } from '@/types/cms'
import styles from './InfoGraphic.module.scss'
import InfographicSwitch from './InfoGraphicSwitch'

const GroupTitle = ({ infographic }: { infographic: InfographicTypes }) =>
  infographic.model.groupedGraphics &&
  infographic.model.fields['group-title'] &&
  infographic.model.fields['group-sub-title'] && (
    <div className={styles.title}>
      <span>{infographic.model.fields['group-title']}</span>
      <span>{infographic.model.fields['group-sub-title']}</span>
    </div>
  )

const Graphics = ({ infographic }: { infographic: InfographicTypes }) => {
  if (infographic.model.groupedGraphics) {
    return infographic.model.fields['layout-type'] === 'default' ||
      infographic.model.fields['layout-type'] === 'use-tabs' ||
      infographic.model.fields['layout-type'] === 'click-through' ? (
      <InfographicSwitch infographic={infographic} />
    ) : (
      <div className={infographic.model.fields['layout-type'] === 'double' ? styles.double : undefined}>
        {infographic.model.groupedGraphics.map((graphic) => (
          <EmbedDataWrapper key={graphic.id} src={graphic['graf-url']} />
        ))}
      </div>
    )
  } else {
    switch (infographic.model.fields.type) {
      case 'datawrapper':
        return infographic.model.fields['graf-url'] && <EmbedDataWrapper src={infographic.model.fields['graf-url']} />
      case 'flourish':
      case 'tableau':
        return infographic.model.fields.html && <EmbedHtml html={infographic.model.fields.html} />
    }
  }
}

const InfoGraphic = ({ infographic }: { infographic: InfographicTypes }) => {
  if (infographic.model.layout === 'teaser') {
    return <div></div>
  }

  return (
    <div className={styles.infographic}>
      <GroupTitle infographic={infographic} />
      <Graphics infographic={infographic} />
    </div>
  )
}

export default InfoGraphic
